import React from 'react';
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-5 border-y border-border-light px-4 relative overflow-hidden" data-id="element-426">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-427"></div>

      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 text-center relative z-10" data-id="element-428">
        <div className="flex items-center gap-2 text-2xl bg-white/5 px-4 py-2 rounded-full border border-white/10 shadow-inner" data-id="element-429">
          <span data-id="element-430">🇲🇽</span>
          <span data-id="element-431">🇪🇸</span>
          <span data-id="element-432">🇦🇷</span>
          <span data-id="element-433">🇨🇱</span>
          <span data-id="element-434">🇨🇴</span>
          <span data-id="element-435">🇺🇾</span>
          <span data-id="element-436">🇵🇪</span>
        </div>
        <p className="text-text-sec text-sm sm:text-base font-medium" data-id="element-437">
          El recurso N.1 elegido por más de{' '}
          <span className="font-bold text-primary drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]" data-id="element-438">
            12,000 docentes
          </span>{' '}
          en toda Latinoamérica y España.
        </p>
      </div>
    </section>;
}